import {
  getMyInfo,
  RecvMsgParser,
  GetAuthList,
  employeeDeptList,
  getBalance,
} from "@/service/GenerateAI/index";
import { logout } from "../../service/commonApi";
import { removeToken } from "../../service/localToken";
import { getCookieVal } from "../../tool/index";
import { MessageBox } from "element-ui";

const menuList = [
  {
    label: "切换空间",
    id: "switchSpace",
    menuShow: false, // 是否在管理中心显示
    navShow: true, // 是否在导航栏显示
    hasAuth: true, // 是否有权限
    link: "",
    icon: "icon-qiehuankongjian",
    isExternalLink: false,
    target: "_self",
  },
  {
    label: "基本模型",
    id: "basicModel",
    menuShow: false,
    navShow: false,
    hasAuth: true,
    link: "/manageCenter/basicModel",
    icon: "icon-jibenmoxing",
    isExternalLink: false,
    target: "_self",
  },
  {
    label: "管理中心",
    id: "myWorks",
    menuShow: false,
    navShow: true,
    hasAuth: true,
    link: "/manageCenter/productManage",
    icon: "icon-guanlizhongxin",
    isExternalLink: false,
    target: "_self",
  },
  {
    label: "我的作品",
    id: "myWorks",
    menuShow: true,
    navShow: false,
    hasAuth: true,
    link: "/manageCenter/collection",
    icon: "icon-wodezuopin1",
    isExternalLink: false,
    target: "_self",
    children: [
      {
        label: "图片作品",
        id: "imageCollection",
        menuShow: true,
        navShow: false,
        hasAuth: true,
        link: "/manageCenter/collection",
        icon: "icon-wodezuopin1",
        isExternalLink: false,
        target: "_self",
      },
      {
        label: "智配报告",
        id: "smartReport",
        menuShow: true,
        navShow: false,
        hasAuth: true,
        link: "/manageCenter/smartReport",
        icon: "icon-wodezuopin1",
        isExternalLink: false,
        target: "_self",
      },
    ],
  },
  {
    label: "产品管理",
    id: "productManage",
    menuShow: true,
    navShow: false,
    hasAuth: true,
    link: "/manageCenter/productManage",
    icon: "icon-peifushengkuan",
    isExternalLink: false,
    target: "_self",
    children: [
      {
        label: "产品管理",
        id: "productManage",
        menuShow: true,
        navShow: false,
        hasAuth: true,
        link: "/manageCenter/productManage",
        icon: "icon-peifushengkuan",
        isExternalLink: false,
        target: "_self",
      },
      {
        label: "虚拟产品",
        id: "virtualProduct",
        menuShow: true,
        navShow: false,
        hasAuth: true,
        link: "/manageCenter/virtualProduct",
        icon: "icon-peifushengkuan",
        isExternalLink: false,
        target: "_self",
      },
      {
        label: "标签管理",
        id: "tagManage",
        menuShow: false,
        navShow: false,
        hasAuth: true,
        link: "/manageCenter/TagManage",
        icon: "icon-peifushengkuan",
        isExternalLink: false,
        target: "_self",
      },
    ],
  },
  {
    label: "原面辅料",
    id: "originalMaterial",
    menuShow: true,
    navShow: false,
    hasAuth: true,
    link: "/manageCenter/originalMaterial",
    icon: "icon-kehuku",
    isExternalLink: false,
    target: "_self",
  },
  {
    label: "客户库",
    id: "customerLibrary",
    menuShow: true,
    navShow: false,
    hasAuth: true,
    link: "/manageCenter/customerLibrary",
    icon: "icon-yuanmianfuliao",
    isExternalLink: false,
    target: "_self",
  },
  {
    label: "知识库",
    id: "knowledgeBase",
    menuShow: true,
    navShow: false,
    hasAuth: true,
    link: "/manageCenter/knowledgeBase",
    icon: "icon-zhishiku",
    isExternalLink: false,
    target: "_self",
  },
  {
    label: "PDF生成",
    id: "pdfGenerate",
    menuShow: true,
    navShow: false,
    hasAuth: true,
    link: "/manageCenter/pdfGenerate",
    icon: "icon-PDFshengcheng",
    isExternalLink: false,
    target: "_self",
  },
  {
    label: "批量套图",
    id: "batchMockup",
    menuShow: false,
    navShow: false,
    hasAuth: true,
    link: "/manageCenter/batchCenter?tool=batch_mockup",
    icon: "icon-piliangtaotu",
    isExternalLink: false,
    target: "_self",
  },
  {
    label: "批量中心",
    id: "batchCenter",
    menuShow: true,
    navShow: false,
    hasAuth: true,
    link: "/manageCenter/batchCenter",
    icon: "icon-piliangzhongxin",
    isExternalLink: false,
    target: "_self",
  },
  {
    label: "瓶款维护",
    id: "bottleMaintain",
    menuShow: false,
    navShow: false,
    hasAuth: true,
    link: "/manageCenter/BottleModel",
    icon: "icon-pingkuanweihu",
    isExternalLink: false,
    target: "_self",
  },
  {
    label: "点数记录",
    id: "pointsRecord",
    menuShow: true,
    navShow: true,
    hasAuth: false,
    link: "/manageCenter/PointsManage",
    icon: "icon-dengpao",
    isExternalLink: false,
    target: "_self",
  },
  {
    label: "团队设置",
    id: "teamSetting",
    menuShow: true,
    navShow: true,
    hasAuth: false,
    link: "/manageCenter/MemberManage",
    icon: "icon-tuanduishezhi",
    isExternalLink: false,
    target: "_self",
    capacity: [],
  },
  {
    label: "版权管理",
    id: "CopyrightManage",
    menuShow: true,
    navShow: true,
    hasAuth: true,
    link:
      process.env.VUE_APP_WORKBENCH + "/#/IntellectualProperty/CopyrightManage",
    icon: "icon-icon-banquandengji",
    isExternalLink: true,
    target: "_blank",
  },
  {
    label: "账号设置",
    id: "accountSetting",
    menuShow: true,
    navShow: true,
    hasAuth: true,
    link: process.env.VUE_APP_LOGIN + "accountCenter",
    icon: "icon-zhanghaoshezhi",
    isExternalLink: true,
    target: "_blank",
  },
];

const state = {
  currentTab: 0,
  balance: 0, // 总数余额
  employeeBalance: 0, // 成员余额
  logo: "",
  userInfo: {
    userInfo: {},
    orgInfo: {},
    orgList: [],
  }, //用户信息
  taskDetail: {}, // 任务详情
  authObject: JSON.parse(sessionStorage.getItem("authObject")) || {}, // 所有权限列表
  curRouterAuth: [], // 当前路由权限列表
  token: getCookieVal("iyuanwu_token") || "", // token
  // 菜单列表
  menuList: menuList,
  employeeList: [], // 成员列表
  employeeId: "", // 当前员工ID
  host: "https://chdesign.oss-cn-shanghai.aliyuncs.com/",
};
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  // 总数余额
  SET_BALANCE: (state, val) => {
    state.balance = val;
  },
  // 成员余额
  SET_EMPLOYEE_BANLANCE: (state, val) => {
    state.employeeBalance = val;
  },
  SET_TASKDETAIL: (state, val) => {
    state.taskDetail = val;
  },
  SET_LOGO: (state, val) => {
    state.logo = val;
  },
  SET_CURRENTTAB: (state, val) => {
    state.currentTab = val;
  },
  SET_ALLAUTHOBJECT: (state, val) => {
    state.authObject = val;
    sessionStorage.setItem("authObject", JSON.stringify(val));
  },
  SET_USERINFO: (state, val) => {
    state.userInfo = val;
  },
  SET_MENULIST: (state, val) => {
    state.menuList = val;
  },
  SET_ROUTER_AUTH: (state, val) => {
    state.curRouterAuth = val;
  },
  SET_EMPLOYEELIST: (state, val) => {
    state.employeeList = val;
  },
  SET_EMPLOYEE_ID: (state, val) => {
    state.employeeId = val;
  },
};
const actions = {
  // 点数余额不足时调用工单提醒
  async sendWorkOrderMsg({ state }) {
    const data = state.userInfo;
    RecvMsgParser({
      Equipment: "pc",
      registerSource: "1",
      Mobile: data.userInfo.phone,
      CaihongNo: data.orgInfo.caihongNO,
      platForm: "AI生成平台",
      name: data.userInfo.name,
      msgHandlecode: "C-AIXHDS",
      content: "客户AI生成消耗点数不足，可提醒客户增购",
    })
      .then(() => {})
      .catch(() => {});
    MessageBox({
      title: "提示",
      message: "您当前没有足够的点数进行此操作，已为您通知工作人员，请稍等",
      confirmButtonText: "我知道了",
    })
      .then(() => {})
      .catch(() => {});
  },
  // 发送工单
  async sendWorkOrder({ state }, { code, content }) {
    const data = state.userInfo;
    const res = await RecvMsgParser({
      Equipment: "pc",
      registerSource: "1",
      Mobile: data.userInfo.phone,
      CaihongNo: data.orgInfo.caihongNO,
      platForm: "AI生成平台",
      name: data.userInfo.name,
      msgHandlecode: code,
      content,
    });
  },

  // 设置token
  setTokenMsg({ commit, dispatch }, token) {
    dispatch("getUserInfo");
    dispatch("getAuthList");
    commit("SET_TOKEN", token);
  },
  updateBalance({ dispatch }) {
    dispatch("getAuthList");
  },
  // 获取当前用户剩余点数
  async getBalance({ commit, state }) {
    const res = await getBalance();
    if (res.code == 1) {
      commit("SET_EMPLOYEE_BANLANCE", res.data.availablePoints);
    }
  },
  // 获取/更新权益列表
  async getAuthList({ commit, dispatch }) {
    const res = await GetAuthList({
      authCodes: [
        "T33",
        "T34",
        "A1",
        "A2",
        "T29",
        "I6",
        "I1",
        "I2",
        "I5",
        "I8",
        "I3",
        "I10",
        "I11",
        "S2",
        "I12",
      ],
    });
    if (res.code == 1) {
      let authObj = {};
      for (const item of res.data) {
        authObj[item.authCode] = item;
      }
      commit("SET_BALANCE", authObj["T34"]?.remain || 0);
      commit("SET_ALLAUTHOBJECT", authObj);
    }
    dispatch("getBalance");
  },
  // 判断是否有所需权限
  hasAuth({ state }, authCodes) {
    let hasAuth = false;
    for (let i = 0; i < authCodes.length; i++) {
      if (
        ["I1", "I2", "A2", "I5", "T33", "I8", "I10", "I11", "I12"].includes(
          authCodes[i]
        )
      ) {
        // 判断是否开通的
        if (state.authObject[authCodes[i]]?.status == 1) {
          hasAuth = true;
          break;
        }
      } else {
        // 判断开通后是否有剩余点数的
        if (
          state.authObject[authCodes[i]]?.status == 1 &&
          state.authObject[authCodes[i]]?.remain > 0
        ) {
          hasAuth = true;
          break;
        }
      }
    }
    return hasAuth;
  },
  // 获取/更新用户信息
  async getUserInfo({ commit, state, dispatch }) {
    const res = await getMyInfo();
    if (res.code == 1) {
      commit("SET_USERINFO", res.data); // 设置用户信息
      commit("SET_EMPLOYEE_ID", res.data.userInfo.employeeId); // 设置当前员工ID
      let logo = res.data.userInfo.avatar.includes("http")
        ? res.data.userInfo.avatar
        : state.host + res.data.userInfo.avatar;
      commit("SET_LOGO", logo); // 设置logo
      // 判断是否有点数管理和团队管理权限
      let hasTeamAuth = false;
      let hasPointsAuth = false;
      let menuList = res.data.menuList;
      let shejiyun = menuList.find((item) => item.path == "/shejiyun");
      let allMenuList = structuredClone(state.menuList);
      if (shejiyun?.children.length > 0) {
        let baseSetting = shejiyun.children.find(
          (item) => item.path == "/BasicSetting"
        );
        if (baseSetting?.children.length > 0) {
          hasPointsAuth = baseSetting.children.find(
            (item) => item.component == "PointsManage"
          )
            ? true
            : false;
          hasTeamAuth = baseSetting.children.find(
            (item) => item.component == "MemberManage"
          )
            ? true
            : false;
          if (hasTeamAuth) {
            allMenuList.find((item) => item.id == "teamSetting").capacity =
              baseSetting.children.find(
                (item) => item.component == "MemberManage"
              ).meta.capacity;
          }
        }
        let IntellectualProperty = shejiyun.children.find(
          (item) => item.path == "/IntellectualProperty"
        );
        if (IntellectualProperty?.children.length > 0) {
          let hasCopyrightAuth = IntellectualProperty.children.find(
            (item) => item.component == "CopyrightManage"
          );
          let CopyrightManage = allMenuList.find(
            (item) => item.id == "CopyrightManage"
          );
          if (hasCopyrightAuth) {
            CopyrightManage.menuShow = true;
            CopyrightManage.navShow = true;
          } else {
            CopyrightManage.menuShow = false;
            CopyrightManage.navShow = false;
          }
        }
      }
      let caihongNo = res.data.orgInfo.caihongNO;
      for (let i = 0; i < allMenuList.length; i++) {
        if (allMenuList[i].id == "bottleMaintain") {
          // 测试和青蛙王子账号可以查看瓶款维护
          if (
            caihongNo == "490486714549141504" ||
            caihongNo == "248171081091776512" ||
            process.env.NODE_ENV == "development"
          ) {
            allMenuList[i].menuShow = true;
            break;
          }
        }
        if (allMenuList[i].id == "basicModel") {
          // 公司号才显示基本模型菜单
          if (
            caihongNo == "191165292" ||
            process.env.NODE_ENV == "development"
          ) {
            allMenuList[i].menuShow = true;
          }
        }
        // orgList为空时不显示切换空间菜单
        if (
          res.data.orgList.length == 0 &&
          allMenuList[i].id == "switchSpace"
        ) {
          allMenuList[i].navShow = false;
        }
      }
      allMenuList.find((item) => item.id == "pointsRecord").hasAuth =
        hasPointsAuth;
      allMenuList.find((item) => item.id == "teamSetting").hasAuth =
        hasTeamAuth;
      commit("SET_MENULIST", allMenuList);
    }
    dispatch("getEmployeeList");
  },
  // 获取成员列表
  async getEmployeeList({ commit }) {
    const res = await employeeDeptList({});
    if (res.code == 1) {
      commit("SET_EMPLOYEELIST", res.data);
    }
  },
  updateTaskDetail({ commit }, data) {
    commit("SET_TASKDETAIL", data);
  },
  updateCurrentTab({ commit }, data) {
    commit("SET_CURRENTTAB", data);
  },
  // 退出登录
  async logout({ commit }) {
    await logout().catch(() => {});
    commit("SET_TOKEN", "");
    commit("SET_USERINFO", {
      userInfo: {},
      orgInfo: {},
      orgList: [],
    });
    commit("SET_ALLAUTHOBJECT", {});
    commit("SET_MENULIST", menuList);
    removeToken();
  },
};

export default {
  // namespaced: true,
  state,
  mutations,
  actions,
};
